import { Injectable } from '@angular/core';
import { catchError, forkJoin, lastValueFrom, of, tap } from 'rxjs';
import { InstituteWebservices } from '@webservices/institute.webservices';
import { BaseWebservices } from '@webservices/base.webservices';
import { SessionStorageService } from '@services/session-storage.service';
import { storageKey } from '@constants/storage.constants';

@Injectable({ providedIn: 'root' })
export class AppInitService {

  constructor(
    private baseApi: BaseWebservices,
    private instituteApi: InstituteWebservices,
    private storage: SessionStorageService
  ) {}

  init() {
    return forkJoin({
      enumData: this.baseApi.getBaseEnum(),
      cityStateData: this.baseApi.getCityState(),
      instituteEnumData: this.instituteApi.getInstituteEnum(),
    }).pipe(
      tap(data => {
        this.storage.set(storageKey.enumData, data.enumData);
        this.storage.set(storageKey.cityState, data.cityStateData);
        this.storage.set(storageKey.instituteEnumData, data.instituteEnumData);
      }),
      catchError(err => {
        console.error('App initialization failed', err);
        return of(null);
      })
    );
  }

  // Helper to return a Promise for Angular initializer
  async initAsPromise(): Promise<void> {
    await lastValueFrom(this.init());
    return void 0;
  }
}
